import React from "react";

function AppTour() {
  return (
    <div>
      <p>
        Click on the app to see the app detail.
      </p>
    </div>
  );
}

export default AppTour;
